import axios from "axios";
import React, {useEffect, useState} from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { useLocation, useNavigate, useParams } from "react-router";
import {useCookies} from 'react-cookie';
import Header from "../components/header/Header";
import SearchBar from "../components/searchBar/SearchBar";
import { intervalLogging, stopLogging} from '../components/common/Logger';
import MajorLeaguePitcherArea from "./league/MajorLeaguePitcherArea";
import MinorLeaguePitcherArea from "./league/MinorLeaguePitcherArea";

function PitcherPage() {
    const [cookies] = useCookies(['hiball_token']);
    const navigate = useNavigate();
    const location = useLocation();
    const {pathname} = location;
    const locationSplit = pathname.split('/');
    const leagueType = locationSplit[1];

    let [profile, setProfile] = useState({
        playerId: null, teamId: null, type: null,
        birthdate: null
    });

    const { playerId } = useParams();

    useEffect(() => {
        if(leagueType !== 'major' && leagueType !== 'minor') {
            console.log(pathname);
            navigate('/major'+pathname);
        } 

        const season = new Date().getFullYear();
        let playerObj = {
            playerType: 'pitcher',
            playerId
        }
        stopLogging();
        intervalLogging(location.pathname, cookies['hiball_token'], playerObj);
        axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'digestRecord', recordName: 'selectProfile',
                pitcherIds: playerId,
                seasons: season,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        }).then((result) => {
            if(result.data.result.length < 1) {
                navigate('/');
            } else {
                setProfile({
                    playerId: playerId,
                    teamId: result['data']['result'][0]['pitcher']['pitcherTeamId'],
                    type: 'pitcher',
                    birthdate: result['data']['result'][0]['pitcher']['birthdate'],
                    pitchingHand: result['data']['result'][0]['pitcher']['pitchingHand']
                });
            }
        });
    }, []);

    const style={
        height: '450px',
        display: 'flex',
        flexDirection: 'column'
    }

    return (
        <>
        <Header title={'투수'}/>
        <Container fluid="xl" className="container">
            <Row>
                <SearchBar/>
            </Row>
            {
                leagueType === 'major'
                ?
                <MajorLeaguePitcherArea profile={profile} />
                :
                (
                leagueType === 'minor'
                ?
                <MinorLeaguePitcherArea profile={profile} />
                :
                <MajorLeaguePitcherArea profile={profile} />
                )
            }
        </Container>
        </>
    )
}

export default PitcherPage;